import { RefetchOptions } from '@tanstack/query-core';
import { useCallback } from 'react';

export type useRefetchQueryProps = {
  enabled: boolean;
  refetch: (options?: RefetchOptions) => Promise<unknown>;
};

export function useRefetchQuery({ enabled, refetch }: useRefetchQueryProps) {
  return useCallback(async () => {
    if (!enabled) {
      return;
    }

    await refetch({ throwOnError: true });
  }, [enabled, refetch]);
}
